import React from "react";
import "./Benefits.css";

const BenefitsPara = () => {
  return (
    <div className="benefitPara">
      <ul>
        <li>
        <span>Personalized Learning Progress:</span>  Track your advancement in the German
          language.
        </li>
        <li>
        <span>Learning Forum:</span>  Get your questions about German grammar and spelling
          answered by our German teacher in our forum.
        </li>
        <li>
        <span>Structured Learning Levels:</span>  All tasks are organized based on the
          German course book and the European Reference Framework.
        </li>
        <li>
        <span>Comprehensive Grammar Rules:</span>  Access explanations for all grammar
          topics.
        </li>
        <li>
        <span>Experienced Teachers:</span>  Prizma Academy boasts a strong faculty of over
          100 experienced teachers. With a presence in 42+ countries, we have
          been conducting online classes for the past 8 years, with over 10000
          students enrolled in our live classes.
        </li>
        <li>
        <span>Live Interactive Sessions:</span>  Prizma Academy conducts live interactive
          sessions that engage both students and faculty.
        </li>
        <li>
        <span>Support Team:</span>  Our dedicated support team is available from 8:30 AM to
          9:00 PM, providing assistance to students throughout the year.
        </li>
        <li>
        <span>WhatsApp Group:</span>  Prizma Academy maintains dedicated WhatsApp groups
          connecting faculty with students, providing real-time updates to all.
        </li>
        <li>
        <span>Special Speaking Classes:</span> We conduct special speaking classes for
          online students across the globe.
        </li>
        <li>
        <span>Admission Team:</span>  Our special Examination Team guides students virtually
          through the entire ecosystem, ensuring a stress-free examination
          experience.
        </li>
        <li>
        <span>Flexible Timings:</span>  To accommodate different time zones, Prizma Academy
          offers multiple time slots, starting from 9 AM in the night till 9:30
          PM.
        </li>
        <li>
        <span>Result Assurance:</span>  Prizma Academy provides specially compiled grammar
          notes for all courses (A1 to C2 level), valued by professionals in the
          industry.
        </li>
      </ul>
    </div>
  );
};

export default BenefitsPara;
